import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=40e7fa75&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=40e7fa75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e7fa75",
  null
  
)

export default component.exports